export const DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX";

export const USERTYPES = {
    PLAYER: 1,
    DEVELOPER: 2,
    OWNER: 3,
    ADMIN: 4,
    GENERAL: 5
};
